import { ArrowLeft, ArrowRight } from "react-feather";
import { Button, Empty } from "antd";
import PackagesViewer from "../PackagesViewer";

const Step3BundlePackages = ({
  loosePackages = [],
  selectedLoosePackages = [],
  setSelectedLoosePackages,
  onCreateShippingFromPackages,
  creatingShipping = false,
  onBack,
  t,
}) => {
  const hasSelection = selectedLoosePackages.length > 0;

  if (!loosePackages.length) {
    return (
      <div style={{ padding: "32px 16px", textAlign: "center" }}>
        <Empty
          description={t(
            "stepper.noBoxesToBundle",
            "No recorded boxes available to bundle. Go back to Step 2 to record physical boxes first.",
          )}
        />
        <div style={{ marginTop: "16px" }}>
          <Button
            size="small"
            onClick={onBack}
            style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
          >
            <ArrowLeft size={14} />
            <span>{t("stepper.backToPack", "Back to Pack Boxes")}</span>
          </Button>
        </div>
      </div>
    );
  }

  const allBoxesSelected =
    loosePackages.length > 0 &&
    selectedLoosePackages.length === loosePackages.length;

  return (
    <div>
      {/* Modern Top Action Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "18px",
          padding: "12px 18px",
          backgroundColor: "#f8fafc",
          borderRadius: "10px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 2px 6px rgba(0,0,0,0.02)",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
          <Button
            size="middle"
            onClick={onBack}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              borderRadius: "8px",
              fontWeight: 500,
            }}
          >
            <ArrowLeft size={15} />
            <span>{t("stepper.backToPack", "Back to Pack Boxes")}</span>
          </Button>

          <Button
            size="small"
            type="dashed"
            onClick={() => {
              if (allBoxesSelected) {
                setSelectedLoosePackages([]);
              } else {
                setSelectedLoosePackages(loosePackages.map((p) => p.id));
              }
            }}
            style={{ borderRadius: "6px", fontSize: "12px" }}
          >
            {allBoxesSelected
              ? t("orderDetails.deselectAll", "Deselect All")
              : t("orderDetails.selectAll", "Select All")}
          </Button>

          <span style={{ fontSize: "13px", color: "#64748b" }}>
            {selectedLoosePackages.length} / {loosePackages.length}{" "}
            {t("stepper.boxesSelected", "boxes selected")}
          </span>
        </div>

        <Button
          type="primary"
          size="middle"
          disabled={!hasSelection || creatingShipping}
          loading={creatingShipping}
          onClick={onCreateShippingFromPackages}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: 600,
            borderRadius: "8px",
            background: hasSelection
              ? "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)"
              : undefined,
            boxShadow: hasSelection
              ? "0 4px 14px rgba(124, 58, 237, 0.35)"
              : "none",
            border: "none",
          }}
        >
          <span>
            {t(
              "orderDetails.createShippingFromPackages",
              "Create Shipping Order from Selected Boxes",
            )}
            {hasSelection && ` (${selectedLoosePackages.length})`}
          </span>
          <ArrowRight size={15} />
        </Button>
      </div>

      {/* Loose packages table with rowSelection */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
        }}
      >
        <PackagesViewer
          packagesList={loosePackages}
          rowSelection={{
            selectedRowKeys: selectedLoosePackages,
            onChange: (selectedKeys) => setSelectedLoosePackages(selectedKeys),
          }}
        />
      </div>
    </div>
  );
};

export default Step3BundlePackages;
